export const dashboardStyles = {
  dashboardSection: {
    background: 'rgba(124, 58, 237, 0.02)',
    borderTop: '1px solid rgba(124, 58, 237, 0.1)'
  },
  dashboardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '24px',
    marginBottom: '32px'
  },
  dashboardCard: {
    background: 'rgba(124, 58, 237, 0.05)',
    border: '1px solid rgba(124, 58, 237, 0.2)',
    borderRadius: '12px',
    padding: '24px'
  },
  dashboardCardTitle: {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  overviewGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
    gap: '16px'
  },
  overviewItem: {
    textAlign: 'center',
    padding: '16px 8px'
  },
  overviewValue: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#8b5cf6',
    marginBottom: '4px'
  },
  overviewLabel: {
    fontSize: '12px',
    color: '#9ca3af',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  realtimeGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
    gap: '16px'
  },
  realtimeItem: {
    background: 'rgba(124, 58, 237, 0.08)',
    padding: '16px',
    borderRadius: '8px',
    border: '1px solid rgba(124, 58, 237, 0.2)'
  },
  realtimeValue: {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '4px'
  },
  realtimeLabel: {
    fontSize: '12px',
    color: '#9ca3af',
    marginBottom: '8px'
  },
  realtimeTrend: {
    fontSize: '12px',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  agentList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  agentListItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px',
    background: 'rgba(124, 58, 237, 0.05)',
    borderRadius: '8px',
    border: '1px solid rgba(124, 58, 237, 0.15)'
  },
  agentInfo: {
    flex: 1
  },
  agentName: {
    fontSize: '14px',
    fontWeight: '500',
    marginBottom: '4px'
  },
  agentStats: {
    fontSize: '12px',
    color: '#9ca3af'
  },
  usageBar: {
    width: '80px',
    height: '6px',
    background: 'rgba(124, 58, 237, 0.2)',
    borderRadius: '3px',
    overflow: 'hidden',
    margin: '0 16px'
  },
  usageProgress: {
    height: '100%',
    background: 'linear-gradient(90deg, #7c3aed, #8b5cf6)',
    borderRadius: '3px'
  },
  statusBadge: {
    fontSize: '10px',
    padding: '4px 8px',
    borderRadius: '12px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    fontWeight: '500'
  },
  categoryChart: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  categoryItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  categoryBar: {
    flex: 1,
    height: '20px',
    background: 'rgba(124, 58, 237, 0.1)',
    borderRadius: '10px',
    overflow: 'hidden',
    position: 'relative'
  },
  categoryProgress: {
    height: '100%',
    background: 'linear-gradient(90deg, #7c3aed, #8b5cf6)',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '8px'
  },
  categoryLabel: {
    fontSize: '11px',
    color: '#ffffff',
    fontWeight: '500'
  },
  categoryPercentage: {
    fontSize: '12px',
    color: '#8b5cf6',
    fontWeight: '500',
    minWidth: '40px'
  },
  alertsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  alertItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '12px',
    background: 'rgba(124, 58, 237, 0.05)',
    borderRadius: '8px',
    border: '1px solid rgba(124, 58, 237, 0.15)'
  },
  alertIcon: {
    width: '16px',
    height: '16px',
    marginTop: '2px'
  },
  alertContent: {
    flex: 1
  },
  alertMessage: {
    fontSize: '14px',
    marginBottom: '4px',
    lineHeight: 1.4
  },
  alertTime: {
    fontSize: '12px',
    color: '#9ca3af'
  }
};